<template>
  <div class="edit-post-form">
    <div v-if="isLoadingSummaryPayload" class="edit-post-form__loading-overlay">
      <Loader class="edit-post-form__loader" />
    </div>
    <!-- Standard page header -->
    <div class="standard-page-header edit-post-form__header">
      <h1 class="global-h1 standard-page-header__title">Edit this Post</h1>
      <!--<div class="standard-page-header__subtitle-and-link">
        <div class="standard-page-header__subtitle">Easily share this post on your preferred social channels!</div>
      </div>-->
    </div>
    <!-- / Standard page header -->

    <div class="edit-post-form__section">
      <div class="edit-post-form__section-title-row">
        <h4 class="global-h4 edit-post-form__section-title">Caption</h4>
        <LinkWithIcon isDottedUnderline color="gray" :isDisabled="isRequestingDownload || props.isSavingPost" @click="copyCapton">
          <template #icon>
            <IconEmbedded v-if="isShowCopied" name="check_2-5" :size="16" />
            <IconEmbedded v-else name="copy_2-5" :size="16" />
          </template>
          <span>{{ isShowCopied ? "copied" : "copy" }}</span>
        </LinkWithIcon>
      </div>
      <!-- Caption edit form -->
      <div class="caption-edit-form edit-post-form__section-content">
        <div v-if="props.postToEdit?.caption" class="caption-edit-form__caption-text" v-html="DOMPurify.sanitize(props.postToEdit.caption)"></div>

        <div class="caption-edit-form__buttons-panel">
          <SrpButton class="media-thumbnails-section__button" size="small" @click="emit('clickEditCaption')" :isDisabled="isRequestingDownload || props.isSavingPost || props.readonlyMode">
            <template #icon><IconEmbedded name="pencil_2" :size="18" /></template>
            Edit Caption
          </SrpButton>
        </div>
      </div>
      <!-- / Caption edit form -->
    </div>

    <div class="edit-post-form__section">
      <div class="edit-post-form__section-title-row">
        <h4 class="global-h4 edit-post-form__section-title">
          Photos<span style="color: rgba(0, 0, 0, 0.5)"> <!--{{ props.postToEdit.assetIds.length }}--></span>
        </h4>
        <LinkWithIcon isDottedUnderline color="gray" :isDisabled="isRequestingDownload || props.isSavingPost" @click="handleDownloadClick">
          <template #icon>
            <LoadingIcon v-if="isRequestingDownload || props.isSavingPost" :size="18" />
            <IconEmbedded v-else name="download_2-5" :size="18" />
          </template>
          <span>download</span>
        </LinkWithIcon>
      </div>
      <!-- Media thumbnails section -->
      <div class="media-thumbnails-section edit-post-form__section-content">
        <div
          :class="{
            'media-thumbnails-section__thumbnails-list-wrap': true,
            'media-thumbnails-section__thumbnails-list-wrap--with-left-curtain': isLeftCurtainVisible,
            'media-thumbnails-section__thumbnails-list-wrap--with-right-curtain': isRightCurtainVisible,
          }"
        >
          <ul class="media-thumbnails-section__thumbnails-list" ref="domRefThumbnailsList">
            <li v-for="(assetId, assetIndex) in props.postToEdit.assetIds" :key="`post-thumb-${props.postToEdit.id}-${assetIndex}-${assetId}`" class="media-thumbnails-section__thumbnail-wrap">
              <SrpFileThumbnail
                class="media-thumbnails-section__thumbnail"
                thumbSize="thumb-tiny"
                :fileName="assetId"
                :isFixedAspectRatio="false"
                :gallery-postfix="props.postToEdit.id"
                isEntireAreaClickable
              />
              <button
                v-if="props.enableSuperUserImageEditingPoc && isImageAssetId(assetId)"
                type="button"
                class="media-thumbnails-section__edit-overlay"
                :disabled="props.readonlyMode || props.isSavingPost"
                :aria-label="'Edit image ' + (assetIndex + 1)"
                @click.stop="openImageEditorModal(assetId, assetIndex)"
              >
                <IconEmbedded name="edit-pencil_2" color="white" :size="16" />
              </button>
            </li>
          </ul>
        </div>

        <div class="media-thumbnails-section__buttons-panel">
          <SrpButton class="media-thumbnails-section__button" size="small" @click="emit('clickEditImages')" :isDisabled="isRequestingDownload || props.isSavingPost">
            <template #icon><IconEmbedded name="image_2-5" :size="18" /></template>
            Choose Images
          </SrpButton>
        </div>
      </div>
      <!-- / Media thumbnails section -->
    </div>

    <div v-if="!props.sectionsToHide.includes(SocialPostEditAndShareFormSections.CreatorTag) && socialShareSummaryPayload?.adventureCreatorSummaries?.length" class="edit-post-form__section">
      <!--<h4 class="global-h4 edit-post-form__section-title">Creator tag</h4>-->

      <!-- Tags copying section -->
      <div class="tags-copying-section edit-post-form__section-content" v-for="creatorSummary in socialShareSummaryPayload.adventureCreatorSummaries" :key="creatorSummary.creatorId">
        <div class="tags-copying-section__left-side">
          <AvatarWithFallback class="tags-copying-section__avatar" :src="creatorSummary.profilePhoto" />
        </div>
        <div class="tags-copying-section__right-side">
          <h5 class="global-h5 tags-copying-section__title">
            {{ creatorSummary.displayName }}
          </h5>
          <SocialMediaLinksBar class="tags-copying-section__handles-row" show-copy-icon :isButtonHaveText="false" :socialFields="creatorSummary.socialFields" />
        </div>
      </div>
      <!-- / Tags copying section -->
    </div>

    <div v-if="false" class="edit-post-form__section">
      <h4 class="global-h4 edit-post-form__section-title">Locations</h4>
      <!-- Tags copying section -->
      <div class="tags-copying-section edit-post-form__section-content">
        <div class="tags-copying-section__left-side">
          <IconEmbedded class="tags-copying-section__location-icon" name="map-pin_1-5" :size="45" />
        </div>
        <div class="tags-copying-section__right-side">
          <h5 class="global-h5 tags-copying-section__title">McDonalds</h5>
          <SocialMediaLinksBar
            class="tags-copying-section__handles-row"
            show-copy-icon
            :isButtonHaveText="false"
            :socialFields="{
              twitterHandle: 'kotofeyweb',
              instagramHandle: '',
              facebookURL: '',
              youtubeURL: 'https://youtube.com/kotofey_web',
              tikTokHandle: '',
            }"
          />
        </div>
      </div>
      <!-- / Tags copying section -->
    </div>

    <div v-if="!props.sectionsToHide.includes(SocialPostEditAndShareFormSections.WhereWasItUsed)" class="edit-post-form__section">
      <h4 class="global-h4 edit-post-form__section-title">
        Where was it used?
        <!-- <span style="color: rgba(0, 0, 0, 0.5); font-weight: 500">(optional)</span>-->
        <InfoIconWithTooltip icon="trending-up_2-5" :width="300"
          >Let us know the url of the post.<br />We're laying the groundwork to track performance so we can help you see what's working!
        </InfoIconWithTooltip>
      </h4>
      <div style="margin-bottom: 7px">Providing a link to the post helps us see how successful it is.</div>

      <div class="edit-post-form__section-content">
        <input class="global-text-input" :disabled="props.isSavingPost" v-model="props.postToEdit.postUrl" style="max-width: 500px" placeholder="https://facebook.com/example" />
      </div>
    </div>

    <SrpModal v-if="props.enableSuperUserImageEditingPoc" v-model:isVisible="isImageEditorModalVisible" width="90vw" size="large" :isClosable="false" :isCloseButtonVisible="true">
      <template #header>
        <h2 class="global-h2">Edit image</h2>
      </template>
      <template #content>
        <div v-if="pinturaErrorMessage" class="pintura-modal-error">{{ pinturaErrorMessage }}</div>
        <InlineImageEditor v-if="selectedImageEditSrc" ref="inlineImageEditorRef" :src="selectedImageEditSrc" :is-busy="isImageEditorBusy" :disabled="isImageEditorBusy" />
      </template>
      <template #footer="{ closeModal }">
        <div class="pintura-modal-footer">
          <SrpButton color="gray" fill="outlined" :isDisabled="isImageEditorBusy || props.isSavingPost" @click="closeImageEditorModal(closeModal)">Cancel</SrpButton>
          <SrpButton :isDisabled="isImageEditorBusy || props.isSavingPost || props.readonlyMode || !selectedImageEditSrc" @click="handleSaveEditedImage(closeModal)">
            <template #icon>
              <LoadingIcon v-if="isImageEditorBusy || props.isSavingPost" :size="18" />
              <IconEmbedded v-else name="save_2-5" :size="18" />
            </template>
            Save
          </SrpButton>
        </div>
      </template>
    </SrpModal>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import ShareStopSummaryRepo from "@repos/ShareStopSummaryRepo";
import { MetricSender } from "@helpers/MetricSender";
import { getGlobalRemoteLogger } from "@helpers/RemoteLogger";
import FileDownload from "@logic/FileDownload";
import DOMPurify from "dompurify";
import FileUtils from "@logic/FileUtils";
import ImageUploader from "@logic/ImageUploader";

// Components
import SrpButton from "@components/ui/SrpButton.vue";
import AvatarWithFallback from "@components/AvatarWithFallback.vue";
import SocialMediaLinksBar from "@components/SocialMediaLinksBar.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";
import Loader from "@components/Loader/Loader.vue";
import SrpFileThumbnail from "@components/ui/SrpFileThumbnail.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import InfoIconWithTooltip from "@components/ui/InfoIconWithTooltip.vue";
import LinkWithIcon from "@components/LinkWithIcon.vue";
import SrpModal from "@components/ui/SrpModal.vue";
import InlineImageEditor from "@components/image-editors/InlineImageEditor.vue";

// Composables
import useScrollCurtains from "@composables/useScrollCurtains";

// Types
import { SocialMediaPostData, SocialShareSummaryPayload } from "@contracts/shareStop";
import { SocialPostEditAndShareFormSections } from "./index.vue";

// Global variables & injections
const remoteLogger = getGlobalRemoteLogger();
const contentBaseUri = globalThis.Bootstrap.Config.contentCdnBaseUri;
// CDN full URLs cause CORS issues with Pintura (same as vue-advanced-cropper in ImageCropper.vue); use blob base + uncompressed.
const EditImageBaseUriPath = `${globalThis.Bootstrap.Config.contentBlobBaseUri}/cms/images/uncompressed/`;

const props = withDefaults(
  defineProps<{
    postToEdit: SocialMediaPostData | null;
    customerId: string;
    isLoadingSummaryPayload: boolean;
    socialShareSummaryPayload: SocialShareSummaryPayload | null;
    savePostCallback: Function;
    isSavingPost: boolean;
    readonlyMode?: boolean;
    sectionsToHide?: Array<SocialPostEditAndShareFormSections>;
    enableSuperUserImageEditingPoc?: boolean;
  }>(),
  {
    postToEdit: null,
    customerId: "",
    isLoadingSummaryPayload: false,
    socialShareSummaryPayload: null,
    savePostCallback: () => {},
    isSavingPost: false,
    readonlyMode: false,
    sectionsToHide: () => [],
    enableSuperUserImageEditingPoc: false,
  }
);

const emit = defineEmits<{
  (e: "clickEditImages"): void;
  (e: "clickEditCaption"): void;
  (e: "requestDownload", value: boolean): void;
}>();

// Creators list curtains =====================================================
const domRefThumbnailsList = ref<HTMLElement | null>(null);
const { isLeft: isLeftCurtainVisible, isRight: isRightCurtainVisible } = useScrollCurtains(domRefThumbnailsList);

// Request download ===========================================================
const isRequestingDownload = ref<boolean>(false);

async function handleDownloadClick() {
  // await props.savePostCallback();
  await requestDownload();
  MetricSender.sendMetric("Cust-SocialPost-Download", { socialPostId: props.postToEdit.id });
}

async function requestDownload() {
  isRequestingDownload.value = true;
  emit("requestDownload", true);

  const downloadId = await ShareStopSummaryRepo.requestDownloadId(props.customerId, props.postToEdit.id);

  isRequestingDownload.value = false;
  emit("requestDownload", false);

  FileDownload.downloadFileByURI(`${contentBaseUri}/${downloadId}`);
}

// Copy caption ===============================================================
const isShowCopied = ref<boolean>(false);

function copyCapton() {
  const text = props.postToEdit.caption;

  navigator.clipboard.writeText(text).then(
    () => console.info("Copied to clipboard: " + text),
    err => console.error("Failed to copy to clipboard: ", err)
  );

  isShowCopied.value = true;
  setTimeout(() => (isShowCopied.value = false), 3000);
}

// Pintura super-user POC (modal + per-thumbnail overlay) ======================
const isImageEditorModalVisible = ref(false);
const isImageEditorBusy = ref(false);
const pinturaErrorMessage = ref<string | null>(null);
const selectedAssetId = ref<string | null>(null);
const selectedAssetIndex = ref<number>(-1);
const inlineImageEditorRef = ref<{ processImage: () => Promise<{ dest?: File } | null> } | null>(null);

function isImageAssetId(assetId: string): boolean {
  return !FileUtils.isVideoFileType(assetId);
}

const selectedImageEditSrc = computed(() => {
  if (!isImageEditorModalVisible.value || !props.enableSuperUserImageEditingPoc || !selectedAssetId.value) return "";
  if (!isImageAssetId(selectedAssetId.value)) return "";
  return `${EditImageBaseUriPath}${selectedAssetId.value}`;
});

function openImageEditorModal(assetId: string, assetIndex: number) {
  if (!props.enableSuperUserImageEditingPoc || props.readonlyMode) return;
  pinturaErrorMessage.value = null;
  selectedAssetId.value = assetId;
  selectedAssetIndex.value = assetIndex;
  isImageEditorModalVisible.value = true;
}

function closeImageEditorModal(closeModal?: (isClickOnBgLayer?: boolean, isForce?: boolean) => void) {
  pinturaErrorMessage.value = null;
  selectedAssetId.value = null;
  selectedAssetIndex.value = -1;
  isImageEditorModalVisible.value = false;
  closeModal?.(false, true);
}

async function handleSaveEditedImage(closeModal?: (isClickOnBgLayer?: boolean, isForce?: boolean) => void) {
  if (!props.postToEdit?.assetIds?.length || selectedAssetIndex.value < 0 || !selectedAssetId.value) return;
  pinturaErrorMessage.value = null;
  isImageEditorBusy.value = true;
  try {
    const result = await inlineImageEditorRef.value?.processImage();
    const dest = result?.dest;
    if (!dest) {
      pinturaErrorMessage.value = "No edited image produced. Apply your changes in the editor, then try Save again.";
      return;
    }
    const mime = dest instanceof Blob ? dest.type : "";
    const ext = mime.includes("png") ? "png" : "jpg";
    const clientFileName = `edited-${props.postToEdit.id}-${Date.now()}.${ext}`;
    // Save it back to the server!
    const newId = await ImageUploader.uploadItineraryImageBlob(dest, true, clientFileName, "social", undefined, {
      isEditedVersion: true,
      editedFromAssetId: selectedAssetId.value,
    });
    if (!newId) throw new Error("Upload did not return an asset id");
    // Update the post!
    const next = [...props.postToEdit.assetIds];
    next[selectedAssetIndex.value] = newId;
    props.postToEdit.assetIds = next;
    await props.savePostCallback();
    closeImageEditorModal(closeModal);
  } catch (err) {
    const detail = err instanceof Error ? err.message : String(err);
    remoteLogger.error(`Pintura save failed: postId=${props.postToEdit?.id ?? "?"} assetIndex=${selectedAssetIndex.value} assetId=${selectedAssetId.value ?? "?"} ${detail}`);
    pinturaErrorMessage.value = err instanceof Error ? err.message : "Could not save edited image";
  } finally {
    isImageEditorBusy.value = false;
  }
}
</script>

<style scoped lang="scss">
// Caption edit form ==========================================================
.caption-edit-form {
  &__caption-text {
    margin-bottom: 13px;
    white-space: pre-wrap;
  }

  &__buttons-panel {
    gap: 12px;
    display: flex;
  }
}

// Media thumbnails section ===================================================
.media-thumbnails-section {
  &__thumbnails-list-wrap {
    position: relative;
    z-index: 0;

    &::before,
    &::after {
      content: "";
      width: 30px;
      height: calc(100% - 5px);
      position: absolute;
      top: 0;
      z-index: 3;
      opacity: 0;
      background: rgba(255, 0, 0, 0.3);
      transition: opacity 0.07s ease-in-out;
      pointer-events: none;
    }

    &::before {
      left: 0;
      background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    }
    &::after {
      right: 0;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    }

    &--with-left-curtain {
      &::before {
        opacity: 1;
      }
    }
    &--with-right-curtain {
      &::after {
        opacity: 1;
      }
    }
  }

  &__thumbnails-list {
    gap: 10px;
    padding: 0 0 10px;
    margin: 0 0 12px;
    display: flex;
    list-style: none;
    position: relative;
    overflow-y: hidden;
    overflow-x: auto;
    scrollbar-width: thin; /* Firefox */
    scrollbar-gutter: stable;
    scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      width: 7px !important;
      height: 7px !important;
    }

    &::-webkit-scrollbar-track {
      background: transparent !important;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 100px;
      background-color: rgba(0, 0, 0, 0.25);
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.35);
    }
  }

  &__thumbnail-wrap {
    flex-shrink: 0;
    position: relative;
    list-style: none;
  }

  &__thumbnail {
    height: 80px;

    :deep(.file-thumbnail__bg-image) {
      width: auto !important;
    }
  }

  &__edit-overlay {
    width: 28px;
    height: 28px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 2px;
    bottom: 2px;
    z-index: 10;
    cursor: pointer;
    color: rgba(255, 255, 255, 1);
    background: rgba(0, 0, 0, 0.55);
    border: none;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);

    &:hover:not(:disabled) {
      background: rgba(0, 0, 0, 0.75);
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }
  }

  &__buttons-panel {
    gap: 12px;
    display: flex;
  }
}

// Tags copying section =======================================================
.tags-copying-section {
  padding: 14px 12px 14px;
  border-radius: 6px;
  display: flex;
  background: rgba(0, 0, 0, 0.05);

  &__left-side {
    display: flex;
    align-items: center;
  }

  &__avatar {
    width: 42px !important;
    margin-right: 10px;
  }

  &__location-icon {
    margin-right: 8px;
  }

  &__right-side {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__title {
    margin-bottom: 5px;
    font-weight: 500;
  }

  &__handles-row {
    padding-left: 6px;
    display: flex;

    :deep(.social-links__in-wrap) {
      justify-content: flex-start;
    }
  }
}

// Edit post form =============================================================
.edit-post-form {
  position: relative;
  z-index: 0;

  &__loading-overlay {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 1;
    background: rgba(255, 255, 255, 0.7);
  }

  &__loader {
    position: fixed;
    inset: calc(50dvh - 100px) auto auto calc(50% - 15px);
  }

  &__header {
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  &__section {
    padding-bottom: 25px;
    margin-bottom: 20px;
    position: relative;

    &::after {
      content: "";
      width: 100%;
      height: 0;
      border-bottom: 1px rgba(0, 0, 0, 0.15) solid;
      position: absolute;
      inset: auto auto 0 0;
    }

    &:last-child {
      padding-bottom: 0;
      margin-bottom: 0;

      &:after {
        display: none;
      }
    }
  }

  &__section-title-row {
    gap: 12px;
    margin-bottom: 7px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;

    .edit-post-form__section-title {
      margin-bottom: 0;
    }
  }

  &__section-title {
    margin-bottom: 7px;
  }

  &__section-content {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__divider {
  }
}

.pintura-modal-error {
  margin-bottom: 12px;
  color: #c00;
  font-size: 14px;
}

.pintura-modal-footer {
  gap: 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
</style>
